import { z } from 'zod';
import {
  sidebarSectionKindSchema,
  sidebarSectionShowSchema,
  sidebarSectionSortSchema,
} from '../enums';
import { uuidSchema } from './common';

/**
 * `SidebarSectionDto` (PLAN §4 "Sidebar sections", D-047, D-176). A leaf file because both the
 * bootstrap (`messaging.ts`) and the sections endpoints (`productivity.ts`) use it.
 */
export const sidebarSectionDtoSchema = z.object({
  id: uuidSchema,
  /** `custom`, or a row storing a system section's order and collapsed state. */
  kind: sidebarSectionKindSchema,
  /** Custom sections only. */
  name: z.string().nullable(),
  emoji: z.string().nullable(),
  sort: sidebarSectionSortSchema,
  show: sidebarSectionShowSchema,
  collapsed: z.boolean(),
  /** Fractional-index key (D-047); sort sections by it with a plain string compare. */
  position: z.string(),
  /** Custom sections: the conversations placed in it, in order. System sections: `[]`. */
  conversationIds: z.array(uuidSchema),
});
export type SidebarSectionDto = z.infer<typeof sidebarSectionDtoSchema>;
